import type { Translation } from '../types.ts';
import type en from '../en/bol.ts';

export default {
    settings: {
        loadFailed: 'Laden van de bol.com-instellingen is mislukt.',
        saved: 'bol.com-instellingen opgeslagen.',
        saveFailed: 'Opslaan van de bol.com-instellingen is mislukt.',
        fulfilmentFbr: 'FBR: je verzendt zelf (Fulfilment by Retailer)',
        fulfilmentFbb: 'FBB: bol verzendt (Fulfilment by bol)',
    },
    connection: {
        title: 'bol.com-koppeling',
        intro: 'Koppel een bol.com Retailer API-account om voorraad door te zetten en bestellingen binnen te halen. De inloggegevens vind je in het verkopersdashboard van bol.com (Instellingen → API). Producten worden op SKU aan bol-aanbiedingen gekoppeld (je SKU is de EAN van het product).',
        clientId: 'Client-ID',
        clientIdPlaceholder: 'Client-ID van de bol.com API',
        clientSecret: 'Client secret',
        secretSavedPlaceholder: '•••••••• (opgeslagen, laat leeg om te behouden)',
        secretPlaceholder: 'Client secret van de bol.com API',
        secretHint: 'Wordt veilig opgeslagen en nooit meer getoond. Laat leeg om het huidige secret te behouden.',
        fulfilmentMethod: 'Fulfilmentmethode',
        test: 'Verbinding testen',
        saveFirst: 'Sla eerst de inloggegevens op.',
        testOk: 'Verbonden met bol.com: de inloggegevens zijn geldig.',
        testRejected: 'bol.com heeft de inloggegevens geweigerd.',
        testUnreachable: 'bol.com is niet bereikbaar.',
    },
    sync: {
        title: 'Synchronisatie',
        pushStock: 'Voorraad naar bol.com sturen',
        pushStockHelp: 'Stuur je beschikbare voorraad naar je bol-aanbiedingen, zodat je niet meer verkoopt dan je hebt.',
        pullOrders: 'Bestellingen van bol.com ophalen',
        pullOrdersHelp: 'Importeer bol-bestellingen, zodat je ze samen met je eigen bestellingen afhandelt.',
        nothingDispatched: 'Er is niets gestart. Zet eerst de bijbehorende synchronisatie aan.',
        queued: 'Synchronisatie ingepland ({directions}). Loopt op de achtergrond.',
        queueFailed: 'Inplannen van de synchronisatie is mislukt.',
    },
    direction: {
        stock: 'voorraad',
        orders: 'bestellingen',
        both: 'voorraad en bestellingen',
    },
    status: {
        lastStockSync: 'Laatste voorraadsynchronisatie',
        lastOrderSync: 'Laatste bestellingensynchronisatie',
        lastStatus: 'Laatste status',
        never: 'nooit',
    },
    verify: {
        title: 'Synchroniseren en controleren',
        intro: 'Synchroniseer nu, of doe eerst een proefrun om precies te zien wat er zou veranderen (in het CMS en op bol.com) voordat er iets wordt weggeschreven.',
        syncStock: 'Voorraad nu synchroniseren',
        pullOrders: 'Bestellingen nu ophalen',
        syncBoth: 'Allebei synchroniseren',
    },
    dryRun: {
        title: 'Proefrun',
        help: 'Alleen lezen. Leest bol.com-aanbiedingen en openstaande bestellingen; schrijft niets weg.',
        run: 'Proefrun starten',
        running: 'Bezig…',
        startFailed: 'Starten van de proefrun is mislukt.',
        computing: 'Verschillen met bol.com berekenen…',
        failed: 'De proefrun is mislukt.',
        stockUpdates: 'geen voorraadwijzigingen | {n} voorraadwijziging | {n} voorraadwijzigingen',
        orderImports: 'geen bestellingen te importeren | {n} bestelling te importeren | {n} bestellingen te importeren',
        warnings: 'geen waarschuwingen | {n} waarschuwing | {n} waarschuwingen',
        computedAt: 'berekend {date}',
        stockTitle: 'Voorraad doorzetten (CMS → bol)',
        bolOffer: 'bol-aanbieding',
        from: 'Van',
        to: 'Naar',
        noStockChanges: 'Geen voorraadwijzigingen: bol is al bijgewerkt.',
        ordersTitle: 'Te importeren bestellingen (bol → CMS)',
        bolOrder: 'bol-bestelling',
        items: 'Artikelen',
        match: 'Koppeling',
        allMatched: 'alles gekoppeld',
        unmatched: '{n} niet gekoppeld',
        noOrders: 'Geen nieuwe bestellingen om te importeren.',
    },
} satisfies Translation<typeof en>;
